import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FilterProvincesBy, ProvincesByCity } from '@app/entities/provinces-cities';
import { AppFacade } from '@app/app.facade';


@Pipe({
  name: 'provincesBy',
  standalone: false
})

export class ProvincesByPipe implements PipeTransform {

  constructor(
    private facade: AppFacade
  ) { }

  transform(code: string, filterBy: FilterProvincesBy = FilterProvincesBy.CityCode): Observable<ProvincesByCity[]> {
    return this.facade.provinces$.pipe(
      map(provinces => {
        if (code) {
          switch (filterBy) {
            case FilterProvincesBy.CityCode:
              return provinces
                .map(province => ({
                  ...province,
                  Cities: province.Cities.filter(city => city.CityCode === code)
                }))
                .filter(province => !!province.Cities.length);
            case FilterProvincesBy.ProvinceId:
              return provinces
                .filter(province => province.ProvinceCode === code);
            case FilterProvincesBy.CountryCode:
              return provinces
                .map(province => ({
                  ...province,
                  Cities: province.Cities.filter(city => city.CountryCode === code)
                }))
                .filter(province => !!province.Cities.length);
            default:
              return [];
          }
        } else return [];
      }));
  }
}
